module.exports = __webpack_public_path__ + "img/back-xs.77b91313.png";